import React from 'react';
import { useRightPanel } from '@/contexts/RightPanelContext';

interface PageWithRightPanelProps {
  readonly children: React.ReactNode;
}

/**
 * Layout wrapper for pages that include a RightPanel.
 * Handles the dynamic padding to push content when panel is open.
 * 
 * Usage:
 * <PageWithRightPanel>
 *   <YourPageContent />
 *   <RightPanel tabs={...} />
 * </PageWithRightPanel>
 */
export function PageWithRightPanel({ children }: PageWithRightPanelProps) {
  const { isExpanded, panelWidth, insightsPanelWidth, showInsights } = useRightPanel();
  
  const getExpandedWidth = () => {
    if (showInsights) {
      return insightsPanelWidth + panelWidth;
    }
    return panelWidth;
  };
  const totalPanelWidth = isExpanded ? getExpandedWidth() : 56;

  return (
    <div 
      className="relative h-full w-full overflow-hidden transition-[padding] duration-[400ms] ease-[cubic-bezier(0.4,0,0.2,1)]"
      style={{ paddingRight: `${totalPanelWidth}px` }}
    >
      {children}
    </div>
  );
}
